import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as sidebarActions from '../../Store/Actions/sidebarActions';

//Components
import Sidebar from '../Containers/sideBar';
import Program from '../Components/ProgramView/program';

class Programpage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name:"Programs"
    }
  }

  buildActionsPannel = () =>{
    var content = this.props.sidebarContent.filter(item=>item.name ===this.state.name)[0].children.map((child,key) => {
       return ( <div key={key} className={child.isActive? "view-action active" :"view-action"} onClick={this.changeViewMode.bind(this,child.name)}>
          <span><FontAwesomeIcon  icon={child.icon} /> {child.name}</span>
        </div>) 
    });


    return content;
  }

  buildOverviewContent =()=>{
    return (
      <div className="view-content">
        Program overview Content<br/>
        <Program/>
      </div>
    )
  }
  buildRisksContent =()=>{
    return (
      <div className="view-content">
        Program risks Content
      </div>
    )
  }
  buildPrimesContent =()=>{
    return (
      <div className="view-content">
        Program primes and deduct Content
      </div>
    )
  }
  buildSinistresContent =()=>{
    return (
      <div className="view-content">
        Program sinistres Content
      </div>
    )
  }
  buildStatContent =()=>{
    return (
      <div className="view-content">
        Program Statistics content
      </div>
    )
  }

  changeViewMode = (mode) =>{
    
    this.props.switchMenuItem(this.props.sidebarContent.findIndex(item=>item.name === this.state.name),this.props.sidebarContent.filter(item=>item.name === this.state.name)[0].children.findIndex(item=>item.name ===mode));
    //this.setState({viewMode:mode});
  }

  render() {
    var viewName = this.state.name + " - " + this.props.sidebarContent.filter(item=>item.name === this.state.name)[0].children.filter(item=>item.isActive === true)[0].name;
    var viewActions = this.buildActionsPannel();
    var viewContent = null;
    switch (this.props.sidebarContent.filter(item=>item.name === this.state.name)[0].children.filter(item=>item.isActive === true)[0].name) {
      case "Overview":
        viewContent = this.buildOverviewContent(this);
        break;
      case "Risks":
        viewContent = this.buildRisksContent(this);
        break;
      case "Prime and Deduct":
        viewContent = this.buildPrimesContent(this);
        break;
      case "Sinistres" :
        viewContent = this.buildSinistresContent(this);
        break;
      case "Statistics" :
        viewContent = this.buildStatContent(this);
        break;
      default:
        viewContent = this.buildOverviewContent(this);
        break;
    }

    return (
      <div className={this.state.name + "page View"}>
        <Sidebar>
        </Sidebar>
        <div className={this.props.sidebarShow ? "Container sideBarOn" : "Container sideBarOff"}>
          <div className="view-container" >
              <div className="view-header">
                <div className="view-title">{viewName}</div>
                <div className="view-actions">
                  {viewActions}
                </div>
              </div>
              {viewContent}
          </div>
        </div>
        
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    sidebarShow: state.appReducer.sidebarShow,
    sidebarContent: state.appReducer.sidebarContent,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    switchMenuItem: (i,j) => dispatch(sidebarActions.switchMenuItem(i,j)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Programpage);


